"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { Flash } from "../../components/flash_messages";
import Vector from "immutable-vector2d";
import fetch from "isomorphic-fetch";
import uuid from "@lukeed/uuid";
import { isPointIn } from "../annotation/bounding_box";
import MODES from "./modes";
import Api from "../../api/api";
export const CHANGE_MODE = "CHANGE_MODE";
export const SET_HOVERED_COMPONENT = "SET_HOVERED_COMPONENT";
export const SELECT_HOVERED_COMPONENT = "SELECT_HOVERED_COMPONENT";
export const SELECT_COMPONENT = "SELECT_COMPONENT";
export const UNSELECT_COMPONENT = "UNSELECT_COMPONENT";
export const ADDING_START = "ADDING_START";
export const ADDING_MOVED = "ADDING_MOVED";
export const ADDING_FINISH = "ADDING_FINISH";
export const MOVING_START = "MOVING_START";
export const MOVING_MOVED = "MOVING_MOVED";
export const MOVING_FINISH = "MOVING_FINISH";
export const MOUSE_MOVED = "MOUSE_MOVED";
export const EDIT_TEXT_ANNOTATION = "EDIT_TEXT_ANNOTATION";
export const editTextAnnotation = (guid) => {
  return function(dispatch, getState) {
    const { textEditingMode, views } = getState();
    const textAnnotation = views.filter((v) => v.guid === guid).first();
    dispatch({
      type: EDIT_TEXT_ANNOTATION,
      textAnnotation
    });
  };
};
export const EDIT_TEXT_ANNOTATION_TEXT = "EDIT_TEXT_ANNOTATION_TEXT";
export const editTextAnnotationText = (guid, value) => {
  return function(dispatch, _getState) {
    dispatch({
      type: EDIT_TEXT_ANNOTATION_TEXT,
      guid,
      value
    });
  };
};
export const DONE_EDITING_TEXT_ANNOTATION = "DONE_EDITING_TEXT_ANNOTATION";
export const doneEditingTextAnnotation = () => {
  return {
    type: DONE_EDITING_TEXT_ANNOTATION
  };
};
export const watchForMouseLeave = (canvasRect, dispatch, getState) => {
  function inner(event) {
    const { mode } = getState();
    const coords = new Vector(event.clientX, event.clientY);
    const rect = [
      [canvasRect.left, canvasRect.top],
      [canvasRect.right, canvasRect.top],
      [canvasRect.right, canvasRect.bottom],
      [canvasRect.left, canvasRect.bottom]
    ];
    if (!isPointIn(coords, rect)) {
      window.removeEventListener("mousemove", inner);
      if (MODES.moving === mode.type) {
        dispatch({
          type: CHANGE_MODE,
          name: MODES.selectOrMove
        });
        dispatch({
          type: MOVING_FINISH
        });
      }
    }
  }
  return inner;
};
export const CANVAS_SIZE_CHANGED = "CANVAS_SIZE_CHANGED";
export function canvasSizeUpdated(width, height) {
  return function(dispatch, getState) {
    const { canvas } = getState();
    const oldCanvasSize = _.isUndefined(canvas.width) ? void 0 : canvas;
    dispatch({
      type: CANVAS_SIZE_CHANGED,
      width,
      height,
      oldCanvasSize
    });
  };
}
export function canvasMouseDown(coords) {
  return function(dispatch, getState) {
    const { mode } = getState();
    switch (mode.type) {
      case MODES.add:
        dispatch({
          type: CHANGE_MODE,
          name: MODES.adding,
          meta: mode.meta
        });
        dispatch({
          type: ADDING_START,
          typeID: mode.meta.typeID,
          guid: uuid(),
          coords
        });
        break;
      case MODES.selectOrMove:
        dispatch({
          type: CHANGE_MODE,
          name: MODES.selectOrMoveMouseDown
        });
        break;
      default:
        return;
    }
  };
}
export function canvasMouseMove(coords, canvasRect) {
  return function(dispatch, getState) {
    dispatch({
      type: MOUSE_MOVED,
      coords
    });
    const {
      mode,
      views,
      mousePos,
      hover: hoveredComponent,
      addingComponent,
      movingComponent,
      annotationMode
    } = getState();
    const cropping = annotationMode.cropping;
    switch (mode.type) {
      case MODES.adding:
        dispatch({
          type: ADDING_MOVED,
          coords,
          addingComponent
        });
        break;
      case MODES.selectOrMoveMouseDown:
        if (hoveredComponent.viewID) {
          dispatch({
            type: CHANGE_MODE,
            name: MODES.moving
          });
          window.addEventListener("mousemove", watchForMouseLeave(canvasRect, dispatch, getState));
          dispatch({
            type: MOVING_START,
            mouseVector: Vector.fromObject(coords),
            component: views[hoveredComponent.viewID],
            dragPointIndex: hoveredComponent.dragPointIndex
          });
        }
        break;
      case MODES.selectOrMove:
        dispatch({
          type: SET_HOVERED_COMPONENT,
          views,
          mousePos,
          mode,
          cropping
        });
        break;
      case MODES.moving:
        dispatch({
          type: MOVING_MOVED,
          mouseVector: Vector.fromObject(coords),
          hoveredComponent,
          movingComponent
        });
        break;
      default:
        return;
    }
  };
}
export function canvasMouseUp(coords) {
  return function(dispatch, getState) {
    const { mode, views, hover } = getState();
    switch (mode.type) {
      case MODES.adding:
        dispatch({
          type: CHANGE_MODE,
          name: MODES.add,
          meta: mode.meta
        });
        dispatch({
          type: ADDING_FINISH,
          coords
        });
        break;
      case MODES.selectOrMoveMouseDown:
        dispatch({
          type: CHANGE_MODE,
          name: MODES.selectOrMove
        });
        dispatch({
          type: SELECT_HOVERED_COMPONENT,
          coords,
          views,
          hover
        });
        break;
      case MODES.moving:
        dispatch({
          type: CHANGE_MODE,
          name: MODES.selectOrMove
        });
        dispatch({
          type: MOVING_FINISH,
          mouseVector: Vector.fromObject(coords)
        });
        break;
      default:
        return;
    }
  };
}
export const KEY_PRESS = "KEY_PRESS";
export function keyPress(key) {
  return {
    type: KEY_PRESS,
    key
  };
}
export const ADD_COMPONENT = "ADD_COMPONENT";
export function addComponent(typeID) {
  return function(dispatch, getState) {
    const guid = uuid();
    const { canvas } = getState();
    var width = 0.3 * canvas.width;
    var height = 0.06 * canvas.width;
    if (typeID == "Stamp") {
      const settings = Api.Account.current().settings;
      height = settings.annotation_stamp_height;
      width = settings.annotation_stamp_width;
    }
    const newProps = {
      x: 0.1 * canvas.width,
      y: 0.1 * canvas.height,
      width,
      height
    };
    dispatch(__spreadProps(__spreadValues({}, newProps), {
      type: ADD_COMPONENT,
      typeID,
      guid,
      canvas
    }));
    const {
      views
    } = getState();
    dispatch({
      type: SELECT_COMPONENT,
      guid,
      views
    });
  };
}
export const DELETE_COMPONENT = "DELETE_COMPONENT";
export function deleteAnnotation(guid) {
  return function(dispatch, getState) {
    const { selected } = getState();
    dispatch({
      type: UNSELECT_COMPONENT,
      guid,
      selected
    });
    dispatch({
      type: DELETE_COMPONENT,
      guid
    });
  };
}
export const CHANGE_COMPONENT_VALUE = "CHANGE_COMPONENT_VALUE";
export function changeComponentValue(guid, value) {
  return {
    type: CHANGE_COMPONENT_VALUE,
    guid,
    value
  };
}
function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  const error = new Error(response.statusText);
  error.response = response;
  throw error;
}
function parseJSON(response) {
  return response.json();
}
export const TOGGLE_ANNOTATING_STATUS = "TOGGLE_ANNOTATING_STATUS";
export const toggleAnnotatingStatus = () => ({
  type: TOGGLE_ANNOTATING_STATUS
});
export const LOADING_ANNOTATIONS = "LOADING_ANNOTATIONS";
export const LOADING_ANNOTATIONS_SUCCEEDED = "LOADING_ANNOTATIONS_SUCCEEDED";
export const LOADING_ANNOTATIONS_FAILED = "LOADING_ANNOTATIONS_FAILED";
const loadAnnotationsFromApi = function(page) {
  return fetch(`/api/document_pages/${page.id}/page_annotations`, {
    method: "get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    credentials: "include"
  }).then(checkStatus).then(parseJSON);
};
const annotationsLoaded = (page, annotations, toneAdjustments) => function(dispatch, getState) {
  const { canvas } = getState();
  dispatch({
    type: LOADING_ANNOTATIONS_SUCCEEDED,
    id: page.id,
    annotations,
    toneAdjustments,
    canvas
  });
};
const newCropAnnotation = () => ({
  left: 0,
  top: 0,
  width: 100,
  height: 100,
  type: "Crop",
  guid: uuid()
});
const addCropIfMissing = (annotations) => {
  if (annotations.filter((a) => a.type === "Crop").length === 0) {
    return annotations.concat([newCropAnnotation()]);
  }
  return annotations;
};
const pageAnnotationsExist = function() {
  return "pageAnnotations" in window;
};
export function loadAnnotations(page) {
  if (pageAnnotationsExist()) {
    return function(dispatch) {
      dispatch(annotationsLoaded(
        page,
        addCropIfMissing(window.pageAnnotations.annotations),
        window.pageAnnotations.toneAdjustments
      ));
    };
  } else {
    return function(dispatch) {
      dispatch({
        type: LOADING_ANNOTATIONS,
        id: page.id
      });
      loadAnnotationsFromApi(page).then((resp) => {
        dispatch(annotationsLoaded(
          page,
          addCropIfMissing(resp.annotations),
          resp.toneAdjustments
        ));
      }).catch((resp) => {
        dispatch({
          type: LOADING_ANNOTATIONS_FAILED,
          id: page.id,
          response: resp
        });
      });
    };
  }
}
export function updateAnnotations(page) {
  return function(dispatch, getState) {
    const { documentPageId } = getState();
    if (page.id !== documentPageId && !pageAnnotationsExist()) {
      dispatch(loadAnnotations(page));
    }
  };
}
export const SAVING_ANNOTATIONS = "SAVING_ANNOTATIONS";
export const SAVING_ANNOTATIONS_SUCCEEDED = "SAVING_ANNOTATIONS_SUCCEEDED";
export const SAVING_ANNOTATIONS_FAILED = "SAVING_ANNOTATIONS_FAILED";
const saveAnnotationsToApi = function(page, annotations, toneAdjustments) {
  return fetch(`/api/document_pages/${page.id}/page_annotations`, {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      annotations,
      toneAdjustments
    }),
    credentials: "include"
  }).then(checkStatus).then(parseJSON);
};
const annotationsSaved = (page, annotations, toneAdjustments) => function(dispatch, getState) {
  const { canvas } = getState();
  dispatch({
    type: SAVING_ANNOTATIONS_SUCCEEDED,
    id: page.id,
    annotations,
    toneAdjustments,
    canvas
  });
};
export const TOGGLE_CROPPING = "TOGGLE_CROPPING";
export function toggleCropping() {
  return function(dispatch, getState) {
    dispatch({
      type: TOGGLE_CROPPING
    });
  };
}
export const TOGGLE_TONE_SLIDERS = "TOGGLE_TONE_SLIDERS";
export function toggleToneSliders() {
  return function(dispatch, getState) {
    dispatch({
      type: TOGGLE_TONE_SLIDERS
    });
  };
}
export const ADJUST_TONE = "ADJUST_TONE";
export function adjustTone(adjustment, value) {
  return function(dispatch, getState) {
    dispatch({
      type: ADJUST_TONE,
      adjustment,
      value
    });
  };
}
export function saveAnnotations(page) {
  return function(dispatch, getState) {
    dispatch({
      type: SAVING_ANNOTATIONS,
      id: page.id
    });
    const { views, canvas, toneAdjustments } = getState();
    const annotations = Object.values(views).map((view) => ({
      height: view.height / canvas.height * 100,
      width: view.width / canvas.width * 100,
      guid: view.guid,
      type: view.typeID,
      data: view.data,
      top: view.y / canvas.height * 100,
      left: view.x / canvas.width * 100,
      id: view.id
    }));
    saveAnnotationsToApi(page, annotations, toneAdjustments).then((resp) => {
      dispatch(
        annotationsSaved(
          page,
          addCropIfMissing(resp.annotations),
          resp.toneAdjustments
        )
      );
    }).catch((resp) => {
      dispatch({
        type: SAVING_ANNOTATIONS_FAILED,
        id: page.id,
        annotations
      });
      Flash.warning("There was a problem saving the annotations. Please try again, and if the problem persists, notify support.");
      throw new Error(resp);
    });
  };
}
